import { Button, Stack, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import DHBackdrop from '../generic/dh-backdrop';
import { Controller, useForm } from 'react-hook-form';
import PasswordLessAuthService from '../../core/service/passwordless-service';
import { useSnackbar } from 'notistack';
import AuthLayout from '../generic/auth-layout';

const EmailVerification = () => {
    const {state} = useLocation();
    let navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [loader, setLoader] = useState<boolean>(false);
    const passwordLessAuthService = new PasswordLessAuthService();
    const defaultData = {
        emailCode: ""
    };
    const {
        handleSubmit,
        control,
    } = useForm({
        defaultValues: defaultData,
    });

    const onSubmit = async (loginData: any) => {
        setLoader(true);
        try {
            const data: any = await passwordLessAuthService.confirmSignIn(loginData.emailCode, state.nextStep.signInStep);
            if(data.nextStep.additionalInfo.challengeType === 'EMAIL') {
                enqueueSnackbar('Invalid mail code', {variant: 'error'});
            } else {
              navigate("/sms-verify", { state: {...data, ...{'userName': loginData.username}} });
            }

        } catch (error) {
            console.log(error);
        } finally {
            setLoader(false);
        }
    };

    return (
        <React.Fragment>
          {loader && <DHBackdrop></DHBackdrop>}
          <AuthLayout
            title="Check your email"
            subtitle="Enter the verification code we just sent to your inbox."
          >
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <Stack spacing={2.5}>
                <Controller
                  name="emailCode"
                  control={control}
                  rules={{
                    required: "This is required",
                    minLength: { value: 6, message: "This is not a valid code" },
                  }}
                  render={({
                    field: { ref, ...field },
                    fieldState: { invalid, error },
                  }) => (
                    <TextField
                      fullWidth
                      autoFocus
                      required
                      label="Email code"
                      {...field}
                      inputRef={ref}
                      error={invalid}
                      helperText={error?.message}
                    />
                  )}
                />
                <Button type="submit" variant="contained" size="large" fullWidth>
                  Verify
                </Button>
              </Stack>
            </form>
          </AuthLayout>
        </React.Fragment>
      );
}

export default EmailVerification;
